module.exports = __webpack_public_path__ + "static/img/lk.03c20243.svg";